import { DATE_RESTRICTION_TYPES } from './constants'

export interface DateRange {
  minDate: string
  maxDate: string
}

export interface ElementWithMeta {
  meta?: {
    control_values?: string[] | null
  }
}

/**
 * Sets up date range restrictions based on element meta control values
 * @param element - Element with meta property containing control_values
 * @returns DateRange object with minDate and maxDate strings
 */
export const setupDateRange = (element?: ElementWithMeta): DateRange => {
  const today = new Date().toISOString().split('T')[0]
  const dateRange: DateRange = {
    minDate: '',
    maxDate: '',
  }

  if (element?.meta?.control_values?.[0] === DATE_RESTRICTION_TYPES?.FUTURE) {
    dateRange.maxDate = today
  } else if (
    element?.meta?.control_values?.[0] === DATE_RESTRICTION_TYPES?.PAST
  ) {
    dateRange.minDate = today
  }

  return dateRange
}
